import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button, Col, Form, Input, Row, Modal, ModalBody, Label } from "reactstrap";
import { handleNotification } from "../../Base/Common/Notification";
import { BlankCard } from "../../Base/Common/CommonUIComponents";
import { putAPI, getAPI } from "../../Base/API";

class ConnectionModal extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.form = React.createRef();
        this.state = {
            block: false,
            selectedConfig: this.props.selectedConfig || {},
            invalidToken: false,
            key: null
        };
    }

    componentDidMount() {        
        if (this.props.selectedConfig?.type == 'GoogleWallet') 
            this.getGoogleWalletData();
    }

    getGoogleWalletData = () => {
        this.setState({ block: true }, () => {
            getAPI(result => {
                const { data, error } = result;
                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState({ invalidToken: true, block: false });
                        return;
                    }
                    if (data.response && data.response[0]) {
                        this.setState({ googleWalletData: data.response[0], block: false });
                        return;
                    }
                }
                this.setState({ block: false });
            }, `/api/Voucher/Wallet/v1/Issuer`);
        });
    }

    saveNewKey = (event, connecion) => {
        event.preventDefault();
        this.setState({ block: true });

        const { apiKey, key, secret } = this.state;

        let params = '';
        if (secret) {
            params = `&secret=${secret}`;
        }

        putAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else {
                    handleNotification(data, <FormattedMessage id="HotelConfig.ConnectionKeySaved" />, <FormattedMessage id="generic.success" />);
                }

                this.props.toggleModal();
            }
            this.setState({ block: false });
        }, `/api/Voucher/Hotel/v1/hotelGroup/apiConnection/${connecion.id}/key?key=${key}${!apiKey ? '' : `&apiKey=${apiKey}`}${params}`);
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        })
    }

    render() {
        const { selectedConfig, googleWalletData } = this.state;

        return (
            <Modal isOpen={this.props.modal} fade={false} className="modal-lg" toggle={this.props.toggleModal}>
                <ModalBody className="p-0">
                    <BlankCard block={this.state.block} error={this.state.error}>
                        <Form onSubmit={(e) => this.saveNewKey(e, selectedConfig)} className="mb-2">
                            <Row className="mb-3">
                                <Col>
                                    <h5>
                                        <FormattedMessage id={selectedConfig.type === "GoogleWallet" ? "HotelConfig.CheckAccount" : "HotelConfig.SetNewKey"} />
                                    </h5>
                                </Col>
                                <Col className="text-right">
                                    <Button className="btn-sm btn-host" type="submit">
                                        <i className="fa-solid fa-floppy-disk" />
                                    </Button>
                                </Col>
                            </Row>

                            {selectedConfig.type === "GoogleWallet" ?
                                googleWalletData && googleWalletData.name ?
                                    <>
                                        <Row className="mb-3">
                                            <Col className="d-flex">
                                                <div className="ml-2">
                                                    <div className="title-sm">
                                                        <FormattedMessage id="HotelConfig.IssuerId" />
                                                    </div>
                                                    <div>
                                                        {googleWalletData.issuerId}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col className="d-flex">
                                                <div className="ml-2">
                                                    <div className="title-sm">
                                                        <FormattedMessage id="HotelConfig.Name" />
                                                    </div>
                                                    <div>
                                                        {googleWalletData.name}
                                                    </div>
                                                </div>
                                            </Col>



                                        </Row>
                                    </>
                                :
                                    <div className="text-center">
                                        <b><FormattedMessage id="HotelConfig.InvalidToken" /></b>
                                    </div>
                            : selectedConfig.type === "StripoSharedAccount" ?
                                <>
                                    <Row>
                                        <Label className="col-2"><FormattedMessage id="HotelConfig.pluginId" /></Label>
                                        <Col className="col-10">
                                            <Input
                                                name="key"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Label className="col-2"><FormattedMessage id="HotelConfig.Secretkey" /></Label>
                                        <Col className="col-10">
                                            <Input
                                                name="secret"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </>
                            :
                                <>
                                    <Row>
                                        <Label className="col-2"><FormattedMessage id="HotelConfig.NewKey" /></Label>
                                        <Col className="col-10">
                                            <Input
                                                name={"key"}
                                                onChange={this.handleChange.bind(this)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Form>
                    </BlankCard>
                </ModalBody>
            </Modal>
        );
    }
}
export default injectIntl(ConnectionModal)